import { render, staticRenderFns } from "./xinYongContent.vue?vue&type=template&id=2112ea1c&scoped=true"
import script from "./xinYongContent.vue?vue&type=script&lang=js"
export * from "./xinYongContent.vue?vue&type=script&lang=js"
import style0 from "./xinYongContent.vue?vue&type=style&index=0&id=2112ea1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2112ea1c",
  null
  
)

export default component.exports